import "jquery-form";
import "jquery-validation";
import "../validator-rules";
import ssoTool from "../tools/sso.tool";
import ssoAlert from "../tools/sso.alert";
import ssoAjax from "../tools/sso.ajax";

export function init() {
    const changePasswordForm = $('#change_password_form');
    const btnSubmit = $('#btn_submit');
    const btnCancel = $('#btn_cancel');

    btnCancel.on('click', function() {
        history.back();
    });

    ssoAjax.checkToken();

    ssoTool.setInputEyeSwitch('#old_password');
    ssoTool.setInputEyeSwitch('#password');
    ssoTool.setInputEyeSwitch('#password_confirm');

    changePasswordForm.validate({
        showErrors: function() {
            if (this.numberOfInvalids() > 0) {
                btnSubmit.addClass('disabled');
            } else {
                btnSubmit.removeClass('disabled');
            }

            this.defaultShowErrors();
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            element.closest('.col').find('div.error-message').html(error);
        },
        submitHandler: function(form) {
            ssoAjax
                .withAuth()
                .setOptions({
                    method: 'put',
                })
                .submit(form, function(response) {
                    try {
                        if (response.status === false) {
                            throw new Error(response.message);
                        }

                        ssoAlert.success(language.password_changed);

                        $(form).resetForm();
                    } catch (e) {
                        ssoAlert.error(e.message);
                    }

                    ssoAjax.btnSetToSubmit();
                })
        }
    });
}
